/* eslint-disable prefer-destructuring */
import materials from '../../core/materials';

export const operations = materials.operations;
export const selectors = materials.selectors;
export default materials;
